// Pure, isomorphic pricing. Used on the post-job form and confirm page,
// and mirrored in the Postgres accept_job_offer function — keep them in sync.

export const HELPER_FEE_RATE = 0.10; // commission deducted from helper payout
export const CUSTOMER_FEE_RATE = 0.05; // service fee added on top
export const CURRENCY = "GBP" as const;

export type PriceBreakdown = {
  subtotal: number;
  helperFee: number;
  customerFee: number;
  total: number;
  helperPayout: number;
};

function round2(n: number) {
  return Math.round(n * 100) / 100;
}

/** Estimate the subtotal from an hourly rate and a duration in minutes. */
export function estimateSubtotal(hourlyRate: number, durationMinutes: number): number {
  return round2(hourlyRate * (durationMinutes / 60));
}

/** Apply fees to a subtotal to get the full breakdown. */
export function applyFees(subtotal: number): PriceBreakdown {
  const helperFee = round2(subtotal * HELPER_FEE_RATE);
  const customerFee = round2(subtotal * CUSTOMER_FEE_RATE);
  const total = round2(subtotal + customerFee);
  const helperPayout = round2(subtotal - helperFee);
  return { subtotal, helperFee, customerFee, total, helperPayout };
}

export function formatGBP(amount: number): string {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: CURRENCY }).format(amount);
}

/** Pence/cents for Stripe amounts. */
export function toMinorUnits(amount: number): number {
  return Math.round(amount * 100);
}
